import './completePurchase.scss';

import React, { useState } from 'react';

import { AddToCartButton } from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Cart/AddToCartButton';
import AvailabilityComponent from '../../components/Primitives/AvailabilityComponent';
import GatsbyImageWrapper from '../GatsbyImageWrapper';
import PriceDisplay from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/ProductSummary/PriceDisplay';
import leftArrowIcon from '../../images/englander-icons/Left-Short-Arrow-Icon.svg';
import popFrontURL from '@progymedia/sbi-web-englander/src/utils/popFrontURL';
import rightArrowIcon from '../../images/englander-icons/Right-Short-Arrow-Icon.svg';
import { useAllProducts } from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Hooks/useAllProducts';
import useMobileDetect from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Hooks/useMobileDetect';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useTranslation } from 'react-i18next';

export default function CompletePurchase(props: {
    options: any;
    lang: string;
}) {
    const { options, lang } = props;

    const { navigateTranslated, currentLocale } = usePageLocalization();
    const { t } = useTranslation('layout');

    const [optionIndex, setOptionIndex] = useState(0);
    const needNavArrows = options.length <= 3 ? false : true;
    const optionLength = options.length;
    const isMobile = useMobileDetect().isMobile();
    const isTablet = useMobileDetect().isTablet();

    return (
        <div className='complete-purchase'>
            <p className='complete-purchase-title'>
                {t('appliance.complete-purchase')}
            </p>

            {!isMobile ? (
                <div className='product_options_listing'>
                    {needNavArrows && (
                        <div className='option-prev option-nav'>
                            <img
                                className={
                                    optionIndex !== 0
                                        ? 'option-image'
                                        : 'option-image not-clickable'
                                }
                                src={leftArrowIcon}
                                alt=''
                                onClick={() =>
                                    optionIndex !== 0 &&
                                    setOptionIndex(optionIndex - 1)
                                }
                            />
                        </div>
                    )}
                    {options.slice(optionIndex, optionIndex + 3).map(
                        (
                            option: {
                                code: string;
                                id: React.Key;
                                title: any;
                            },
                            currentOptionIndex: number
                        ) => (
                            <ProductOption
                                key={`${option.id}-${currentOptionIndex}`}
                                option={
                                    options?.[optionIndex + currentOptionIndex]
                                }
                                currentLocale={currentLocale}
                                navigateTranslated={navigateTranslated}
                                lang={lang}
                            />
                        )
                    )}
                    {optionLength === 1 && (
                        <>
                            <div className='product_option empty' />
                            <div className='product_option empty' />
                        </>
                    )}
                    {optionLength === 2 && (
                        <div className='product_option empty' />
                    )}
                    {needNavArrows && (
                        <div className='option-next option-nav'>
                            <img
                                className={
                                    optionIndex < options.length - 3
                                        ? 'option-image'
                                        : 'option-image not-clickable'
                                }
                                src={rightArrowIcon}
                                alt=''
                                onClick={() =>
                                    optionIndex < options.length - 3 &&
                                    setOptionIndex(optionIndex + 1)
                                }
                            />
                        </div>
                    )}
                </div>
            ) : (
                <div className='product_options_listing mobile'>
                    <div className='option-prev option-nav'>
                        <img
                            className='option-image'
                            src={leftArrowIcon}
                            alt=''
                            onClick={() => {
                                if (optionIndex - 1 >= 0)
                                    setOptionIndex(optionIndex - 1);
                                else setOptionIndex(optionLength - 1);
                            }}
                        />
                    </div>

                    <ProductOption
                        option={options?.[optionIndex]}
                        currentLocale={currentLocale}
                        navigateTranslated={navigateTranslated}
                        lang={lang}
                    />

                    {isTablet && (
                        // Pour tablette, on affiche 2 recommandations au lieu d'une seule
                        <ProductOption
                            option={
                                options?.[
                                    optionIndex === 2 ? 0 : optionIndex + 1
                                ]
                            }
                            currentLocale={currentLocale}
                            navigateTranslated={navigateTranslated}
                            lang={lang}
                        />
                    )}

                    <div className='option-next option-nav'>
                        <img
                            className='option-image'
                            src={rightArrowIcon}
                            alt=''
                            onClick={() => {
                                if (optionIndex + 1 > options.length - 1)
                                    setOptionIndex(0);
                                else setOptionIndex(optionIndex + 1);
                            }}
                        />
                    </div>
                </div>
            )}
        </div>
    );
}

function ProductOption(props: {
    option: any;
    currentLocale: any;
    navigateTranslated: any;
    lang: any;
}) {
    const { option, currentLocale, navigateTranslated, lang } = props;
    const [allProducts] = useAllProducts();
    const products = allProducts.nodes;
    const product = products.find(
        (product: { code: string }) => product.code === option?.code
    );
    const { t } = useTranslation('layout');

    return (
        <div className='product_option' key={option?.id}>
            <div
                className='product_option_image'
                onClick={() => {
                    navigateTranslated(
                        popFrontURL(product?.slug?.[currentLocale], 2)
                    );
                }}
            >
                <GatsbyImageWrapper fields={product?.fields} />
            </div>
            <div className='product_option_details'>
                <p className='code'>{option?.code}</p>
                <p className='title'>{option?.title?.[lang]}</p>
                <AvailabilityComponent product={product} />
                <span className='price'>
                    <PriceDisplay sku={option?.code} />
                </span>
                <AddToCartButton
                    className={`addToCart`}
                    label={t('addToCartBtn.add-to-cart')}
                    product={product}
                    showCartIcon={false}
                    openQuickCart={false}
                />
            </div>
        </div>
    );
}
